(() => {
  'use strict';
  if (window.skyroverOctoberCouponReady) return;
  window.skyroverOctoberCouponReady = true;
  const start = Date.parse('2026-10-01T07:00:00Z');
  const end = Date.parse('2026-11-01T07:00:00Z');
  const directStart = Date.parse('2026-10-06T07:00:00Z');
  const directEnd = Date.parse('2026-10-08T07:00:00Z');

  function refresh(row) {
    const now = Date.now();
    const direct = now >= directStart && now < directEnd;
    const price = Number(row.dataset.price);
    const target = Number(row.dataset.target);
    row.hidden = now < start || now >= end || (direct && price > target);
    if (row.hidden) return;
    const noCode = price <= target;
    row.querySelector('[data-copy-october-code]').hidden = noCode;
    row.querySelector('[data-coupon-note]').textContent =
      (noCode ? '' : 'Enter at checkout. ') + 'Per drone. Ends Oct 31 (PT).';
    const instruction = row.querySelector('[data-coupon-instruction]');
    instruction.textContent = noCode ? 'No code needed' : 'with code ';
    if (!noCode) {
      const code = document.createElement('strong');
      code.className = 'october-coupon__code';
      code.textContent = row.dataset.code;
      instruction.append(code);
    }
  }
  function refreshAll() { document.querySelectorAll('[data-october-coupon]').forEach(refresh); }
  // Delegation survives the theme's existing server-rendered price replacement.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-copy-october-code]');
    if (!button) return;
    const row = button.closest('[data-october-coupon]');
    refresh(row);
    if (row.hidden || button.hidden || button.disabled) return;
    const status = row.querySelector('[data-copy-status]');
    button.disabled = true;
    try {
      await navigator.clipboard.writeText(row.dataset.code);
      status.textContent = 'Code copied. Paste it at checkout.';
    } catch (_) {
      status.textContent = 'Copy manually: ' + row.dataset.code;
    } finally {
      button.disabled = false;
    }
  });
  document.addEventListener('variant:change', refreshAll);
  document.addEventListener('shopify:section:load', refreshAll);
  document.addEventListener('visibilitychange', refreshAll);
  window.addEventListener('pageshow', refreshAll);
  refreshAll();
})();
